import { render, staticRenderFns } from "./_base-order-modal.vue?vue&type=template&id=73842f7c&scoped=true"
import script from "./_base-order-modal.vue?vue&type=script&lang=js"
export * from "./_base-order-modal.vue?vue&type=script&lang=js"
import style0 from "./_base-order-modal.vue?vue&type=style&index=0&id=73842f7c&prod&lang=postcss&scoped=true"
import style1 from "./_base-order-modal.vue?vue&type=style&index=1&id=73842f7c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73842f7c",
  null
  
)

export default component.exports